<template>
  <div class="download">
    <div class="download-inner main">
      <div class="dowload-intro">
        <a
          target="_blank"
          href="https://apps.apple.com/cn/app/%E5%92%95%E6%AF%94ai%E8%AF%BE/id1521613788"
          class="download-btn iphone"
          >iPhone下载</a
        >
        <a
          href="https://static-ai.61info.com/pjx/apk/2.8.0_10001_i61.apk"
          class="download-btn android"
          >Android下载</a
        >
        <div class="download-app-qrcode"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './index.scss';
</style>

<script>
export default {
  name: 'Download',
  mounted() {
    let u = navigator.userAgent
    let browser = {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1,
    }
    //是否是移动端
    if (
      browser.mobile ||
      browser.ios ||
      browser.android ||
      browser.iPhone ||
      browser.iPad
    ) {
      if (window.document.documentElement.clientWidth <= 1170) {
        document.getElementById('header').style.position = 'absolute'
      }
    }
  },
  beforeDestroy() {
    document.getElementById('header').style.position = 'fixed'
  },
}
</script>
